 enum Page {
  NOT_FOUND, HOME, SONG
}

export default Page